<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  props: {
    text: { required: true, type: String },
    color: { default: 'green', type: String },
    size: { default: 'unset', type: String },
  },
  computed: {
    dynamicClasses() {
      if (this.size === 'small') {
        return ['cly-vue-status-tag--small', `cly-vue-status-tag--${this.color}`];
      }
      return `cly-vue-status-tag--${this.color}`;
    },
  },
});
</script>
<template>
  <div
    class="cly-vue-status-tag"
    :class="dynamicClasses"
  >
    <div class="cly-vue-status-tag__blink" />
    {{ text }}
  </div>
</template>
